import { ImpactOrderStatus } from '@prisma/client';

export const RESERVED_STOCK_ORDER_STATUSES = [
  ImpactOrderStatus.AGGREGATION_PENDING,
  ImpactOrderStatus.AGGREGATION_LOCKED,
  ImpactOrderStatus.AGGREGATION_COMPLETE,
  ImpactOrderStatus.PAYMENT_PENDING,
  ImpactOrderStatus.PAYMENT_FAILED,
  ImpactOrderStatus.PAYMENT_COMPLETE,
] as const satisfies ImpactOrderStatus[];
